<div class="AccountSettings">
  <h4>Account Settings</h4>
  <p>
    Select Update Preferences to customize your sales goals. Select Pipeline
    Feature to turn on and set your pipeline steps.
  </p>
  <div class="container">
    <div class="AccountSettings-buttons row">
      <app-button
        class="AccountSettings-buttons-button col col-12 col-md-6"
        [color]="preferencesButtonProperties.color"
        [size]="preferencesButtonProperties.size"
        [text]="preferencesButtonProperties.text"
        [route]="preferencesButtonProperties.route"></app-button>
      <app-button
        class="AccountSettings-buttons-button col col-12 col-md-6"
        [color]="pipelineButtonProperties.color"
        [size]="pipelineButtonProperties.size"
        [text]="pipelineButtonProperties.text"
        [route]="pipelineButtonProperties.route"></app-button>
    </div>
  </div>
</div>
